import React, { useEffect, useState, useRef } from "react";
import "../NFTDetailDesign.css";
import "./History.css";
import { getNftHistory } from "../../../api/nft/nft";
import { errorMessageHandler, fetchHistoryDetail, formatTime } from "../../../utils/utils";
import LoadMoreSection from "../../Common/LoadMoreSection";


const History = ({ id,refresh }) => {

    const [nftHistoryLoading, setNftHistoryLoading] = useState(true)
    const [nftHistoryError, setNftHistoryError] = useState("")
    const [nftHistory, setNftHistory] = useState([])
    const [nftHistoryPagnation, setNftHistoryPagination] = useState({})
    const [fetchHistoryPage, setFetchHistoryPage] = useState(1)
    const [loadMore, setLoadMore] = useState(false)
    const [containerHeight, setContainerHeight] = useState(400)
    const activityContainerRef = useRef(null)

    // Calculate responsive height
    useEffect(() => {
        const updateHeight = () => {
            if (window.innerWidth >= 992) {
                setContainerHeight(550)
            } else if (window.innerWidth >= 768) {
                setContainerHeight(500)
            } else if (window.innerWidth >= 576) {
                setContainerHeight(450)
            } else {
                setContainerHeight(400)
            }
        }

        updateHeight()
        window.addEventListener('resize', updateHeight)
        return () => window.removeEventListener('resize', updateHeight)
    }, [])

    useEffect(() => {
        getNftActivity(fetchHistoryPage)
    }, [])

    useEffect(() => {
        getNftActivity(1)
    }, [refresh])

    // Prevent page scroll when scrolling inside history
    useEffect(() => {
        const container = activityContainerRef.current;
        if (!container) return;

        const handleWheel = (e) => {
            const { scrollTop, scrollHeight, clientHeight } = container;
            const scrollable = scrollHeight > clientHeight;

            // Only prevent default if the container is scrollable
            // This prevents page scroll while scrolling inside history
            if (scrollable) {
                e.stopPropagation();
            }
        };

        // Use passive: false to allow preventDefault if needed
        container.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            container.removeEventListener('wheel', handleWheel);
        };
    }, [nftHistory]);

    let getNftActivity = async (page = fetchHistoryPage) => {
        try {

            setLoadMore(true)
            let { data } = await getNftHistory(id, page)
            const incoming = data?.data?.history || [];
            const pagination = data?.data?.pagination || {};
            setNftHistory(prev => (page === 1 ? incoming : [...prev, ...incoming]));
            setNftHistoryPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            })
            setNftHistoryLoading(false)
            setLoadMore(false)
        }
        catch (e) {
            setLoadMore(false)
            setNftHistoryLoading(false)
            setNftHistoryError(errorMessageHandler(e))
        }
    }

    useEffect(() => {
        if (fetchHistoryPage > 1) getNftActivity();
    }, [fetchHistoryPage]);


    const loadMoreHistory = () => {
        if (nftHistoryPagnation?.has_next_page) setFetchHistoryPage(prev => prev + 1);
    };

    // Get action icon and color based on action type
    const getActionStyles = (action) => {
        const styles = {
            minted: {
                icon: '✨',
                color: '#10b981',
                bgColor: 'rgba(16, 185, 129, 0.1)',
                borderColor: 'rgba(16, 185, 129, 0.3)'
            },
            listed: {
                icon: '🏷️',
                color: '#3b82f6',
                bgColor: 'rgba(59, 130, 246, 0.1)',
                borderColor: 'rgba(59, 130, 246, 0.3)'
            },
            sold: {
                icon: '💰',
                color: '#f59e0b',
                bgColor: 'rgba(245, 158, 11, 0.1)',
                borderColor: 'rgba(245, 158, 11, 0.3)'
            },
            transferred: {
                icon: '🔄',
                color: '#8b5cf6',
                bgColor: 'rgba(139, 92, 246, 0.1)',
                borderColor: 'rgba(139, 92, 246, 0.3)'
            },
            cancelled: {
                icon: '❌',
                color: '#ef4444',
                bgColor: 'rgba(239, 68, 68, 0.1)',
                borderColor: 'rgba(239, 68, 68, 0.3)'
            },
            default: {
                icon: '📝',
                color: '#6b7280',
                bgColor: 'rgba(107, 114, 128, 0.1)',
                borderColor: 'rgba(107, 114, 128, 0.3)'
            }
        };
        return styles[action?.toLowerCase()] || styles.default;
    };

    return (
        <div
            className="tab-pane fade"
            id="activity"
            role="tabpanel"
            aria-labelledby="activity-tab"
        >

            {
                nftHistoryLoading === true ? (
                    <div
                        className="NftHistory__activity"
                        style={{
                            height: `${containerHeight}px`,
                            maxHeight: `${containerHeight}px`,
                            minHeight: `${containerHeight}px`,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div className="NftHistory__loadingState">
                            <div className="NftHistory__loadingSpinner"></div>
                            <p style={{ marginTop: '20px', color: '#6b7280', fontSize: '15px' }}>Loading history...</p>
                        </div>
                    </div>
                ) : nftHistoryError ? (
                    <div
                        className="NftHistory__activity"
                        style={{
                            height: `${containerHeight}px`,
                            maxHeight: `${containerHeight}px`,
                            minHeight: `${containerHeight}px`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div className="text-center py-4" style={{ maxWidth: '450px', padding: '30px 20px' }}>
                            {/* Error Icon Container */}
                            <div style={{
                                width: '120px',
                                height: '120px',
                                margin: '0 auto 24px',
                                background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.08), rgba(220, 38, 38, 0.08))',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '3px solid rgba(239, 68, 68, 0.2)',
                                position: 'relative'
                            }}>
                                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ef4444', filter: 'drop-shadow(0 4px 16px rgba(239, 68, 68, 0.3))' }}>
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="8" x2="12" y2="12"></line>
                                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                                </svg>
                            </div>

                            {/* Error Title */}
                            <h3 style={{
                                color: '#1a1a1a',
                                marginBottom: '12px',
                                fontSize: '26px',
                                fontWeight: '700',
                                lineHeight: '1.2',
                                letterSpacing: '-0.5px'
                            }}>
                                Unable to Load History
                            </h3>

                            {/* Error Message */}
                            <p style={{
                                color: '#6b7280',
                                fontSize: '15px',
                                lineHeight: '1.6',
                                marginBottom: '0',
                                fontWeight: '500'
                            }}>
                                Something went wrong while loading the NFT history. Please try again later.
                            </p>
                        </div>
                    </div>
                ) : nftHistory?.length === 0 ? (
                    <div
                        className="NftHistory__activity"
                        style={{
                            height: `${containerHeight}px`,
                            maxHeight: `${containerHeight}px`,
                            minHeight: `${containerHeight}px`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <div className="text-center py-4" style={{ maxWidth: '450px', padding: '30px 20px' }}>
                            {/* Icon Container */}
                            <div style={{
                                width: '120px',
                                height: '120px',
                                margin: '0 auto 24px',
                                background: 'linear-gradient(135deg, rgba(17, 207, 243, 0.1), rgba(105, 239, 183, 0.1))',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '3px solid rgba(17, 207, 243, 0.2)',
                                position: 'relative',
                                animation: 'iconFloat 3s ease-in-out infinite'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: '120%',
                                    height: '120%',
                                    background: 'radial-gradient(circle, rgba(17, 207, 243, 0.2) 0%, rgba(105, 239, 183, 0.15) 40%, transparent 70%)',
                                    borderRadius: '50%',
                                    animation: 'glowPulse 3s ease-in-out infinite'
                                }}></div>
                                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#11cff3', filter: 'drop-shadow(0 4px 16px rgba(17, 207, 243, 0.4))', position: 'relative', zIndex: 1 }}>
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                            </div>

                            {/* Title */}
                            <h2 style={{
                                color: '#1a1a1a',
                                marginBottom: '12px',
                                fontSize: '26px',
                                fontWeight: '700',
                                lineHeight: '1.2',
                                letterSpacing: '-0.5px'
                            }}>
                                No Activity Yet
                            </h2>

                            {/* Description */}
                            <p style={{
                                color: '#6b7280',
                                fontSize: '15px',
                                lineHeight: '1.6',
                                marginBottom: '0',
                                fontWeight: '500'
                            }}>
                                This NFT doesn't have any history yet.<br />
                                Activity will appear here once transactions occur!
                            </p>
                        </div>
                    </div>
                ) : (

                    <div
                        className="NftHistory__activity"
                        ref={activityContainerRef}
                        style={{
                            height: `${containerHeight}px`,
                            maxHeight: `${containerHeight}px`,
                            minHeight: `${containerHeight}px`,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            display: 'block'
                        }}
                    >
                        <div className="NftHistory__timeline">
                            {nftHistory?.map((a, i) => {
                                const actionStyles = getActionStyles(a?.action);
                                return (
                                    <div key={i} className="NftHistory__timelineItem">
                                        <div className="NftHistory__timelineLine"></div>
                                        <div
                                            className="NftHistory__timelineDot"
                                            style={{
                                                background: actionStyles.bgColor,
                                                borderColor: actionStyles.borderColor
                                            }}
                                        >
                                            <span style={{ fontSize: '16px' }}>{actionStyles.icon}</span>
                                        </div>
                                        <div className="NftHistory__timelineContent">
                                            <div className="NftHistory__card">
                                                <div className="NftHistory__cardHeader">
                                                    <span
                                                        className="NftHistory__actionBadge"
                                                        style={{
                                                            background: actionStyles.bgColor,
                                                            color: actionStyles.color,
                                                            borderColor: actionStyles.borderColor
                                                        }}
                                                    >
                                                        {a?.action && a.action.charAt(0).toUpperCase() + a.action.slice(1)}
                                                    </span>
                                                    <span className="NftHistory__timestamp">
                                                        {formatTime(a?.timestamp)}
                                                    </span>
                                                </div>
                                                <div className="NftHistory__cardBody">
                                                    {fetchHistoryDetail(a?.action, a?.price, a.to_user_details, a.from_user_details)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <LoadMoreSection
                            hasNextPage={nftHistoryPagnation?.has_next_page}
                            onLoadMore={loadMoreHistory}
                            isLoading={loadMore}
                            loadMoreText="Load More History"
                            endMessage="That's all the history!"
                            accentColor="17, 207, 243"
                            compact={true}
                        />
                    </div>
                )
            }
        </div>

    );
};

export default History;